import { useState } from 'react';

export default function Contact() {
  const [isSending, setIsSending] = useState(false);
  const [formStatus, setFormStatus] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSending(true);
    setFormStatus('');

    const formData = new FormData(event.currentTarget);
    formData.append('_captcha', 'false');
    formData.append('_subject', formData.get('subject') || 'KAFA Contact Form');

    try {
      const formObject = Object.fromEntries(formData.entries());

      const response = await fetch('https://formsubmit.co/ajax/kafaaward@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(formObject),
      });

      if (!response.ok) {
        throw new Error('Message failed to send.');
      }

      event.currentTarget.reset();
      setFormStatus('Thank you. Your message has been sent.');
    } catch (error) {
      setFormStatus('Sorry, your message could not be sent. Please try again.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-intro">
        <p className="general-header">
          Info
        </p>
        <p className="general-text-col">
          Sign up for our newsletter to stay up to date with new developments from our organization!
        </p>
        <a
          className="contact-newsletter-button"
          href="https://mailchi.mp/1356f9e45eeb/mailing-list-sign-up"
          target="_blank"
          rel="noreferrer"
        >
          Mailing List Signup
        </a>
      </div>
    
      <div>
        <p className="general-header">
          Send a message
        </p>

        <form className="contact-form" onSubmit={handleSubmit}>
          <label>
            <span style={{ fontSize: '1.2rem', fontWeight: '700', color: 'var(--purple-dark)' }}>Your Name (required)</span>
            <input name="name" type="text" required />
          </label>

          <label>
            <span style={{ fontSize: '1.2rem', fontWeight: '700', color: 'var(--purple-dark)' }}>Your Email (required)</span>
            <input name="email" type="email" required />
          </label>

          <label>
            <span style={{ fontSize: '1.2rem', fontWeight: '700', color: 'var(--purple-dark)' }}>Subject</span>
            <input name="subject" type="text" />
          </label>

          <label>
            <span style={{ fontSize: '1.2rem', fontWeight: '700', color: 'var(--purple-dark)' }}>Your Message</span>
            <textarea name="message" rows="7" />
          </label>

          <button type="submit" disabled={isSending}>
            {isSending && <span className="loading-dot" aria-hidden="true" />}
            <span style={{ fontSize: '1.2rem', fontWeight: '700', color: 'var(--slate-950)' }}>{isSending ? 'SENDING' : 'SEND'}</span>
          </button>
          {formStatus && <p className="contact-form-status">{formStatus}</p>}
        </form>
      </div>
    </section>
  );
}
